import { Vector2 } from "../common/vector2.js";
import { Game } from "../game.js";

export class BasicEventsController
{
  private canvas: HTMLCanvasElement;
  private isEnabled: boolean = false;
  private isInitialized: boolean = false;

  private onDown?: ( point: Vector2 ) => void;
  private onUp  ?: ( point: Vector2 ) => void;
  private onMove?: ( point: Vector2 ) => void;

  private boundTouchStart?: (e: TouchEvent) => void;
  private boundTouchEnd?: (e: TouchEvent) => void;
  private boundTouchMove?: (e: TouchEvent) => void;
  private boundMouseDown?: (e: MouseEvent) => void;
  private boundMouseUp?: (e: MouseEvent) => void;
  private boundMouseMove?: (e: MouseEvent) => void;

  private use_global_mouse_events = false;
  private stop_event_propagation = false;

  //private bounding_client_rect?: DOMRect;

  constructor( canvas: HTMLCanvasElement )
  {
    this.canvas = canvas;
  }

  public init(
    onDown: ( point: Vector2 ) => void,
    onUp  : ( point: Vector2 ) => void,
    onMove: ( point: Vector2 ) => void,
    use_global_mouse_events: boolean = false,
    stop_event_propagation: boolean = false
  ): void
  {
    if ( this.isInitialized )
    {
      console.warn( "BasicEventsController: Controller already initialized, cleaning up first" );
      this.cleanup();
    }

    this.onDown = onDown;
    this.onUp   = onUp;
    this.onMove = onMove;

    this.use_global_mouse_events = use_global_mouse_events;
    this.stop_event_propagation = stop_event_propagation;

    //this.bounding_client_rect = this.canvas.getBoundingClientRect();
    //console.log( `BasicEventsController.init()   this.bounding_client_rect ${this.bounding_client_rect.x}, ${this.bounding_client_rect.y}, ${this.bounding_client_rect.left}, ${this.bounding_client_rect.top}, ${this.bounding_client_rect.width}, ${this.bounding_client_rect.height}` );

    this.bindEvents( this.canvas );
    this.isEnabled = true;
    this.isInitialized = true;
  }

  private bindEvents( canvas: HTMLCanvasElement ): void
  {
    this.boundTouchStart = ( e ) => this.onTouchDownBEC( e );
    this.boundTouchEnd = ( e ) => this.onTouchUpBEC( e );
    this.boundTouchMove = ( e ) => this.onTouchMoveBEC( e );
    this.boundMouseDown = ( e ) => this.onMouseDownBEC( e );
    this.boundMouseUp = ( e ) => this.onMouseUpBEC( e );
    this.boundMouseMove = ( e ) => this.onMouseMoveBEC( e );

    if ( Game.isMobile() )
    {
      canvas.addEventListener( "touchstart", this.boundTouchStart, { passive: false } );
      canvas.addEventListener( "touchend"  , this.boundTouchEnd, { passive: false } );
      canvas.addEventListener( "touchmove" , this.boundTouchMove, { passive: false } );
    } else
    {
      if ( this.use_global_mouse_events )
      {
        window.addEventListener( "pointerdown", this.boundMouseDown );
        window.addEventListener( "pointerup", this.boundMouseUp );
        window.addEventListener( "pointermove", this.boundMouseMove );
      } else
      {
        canvas.addEventListener( "pointerdown", this.boundMouseDown );
        canvas.addEventListener( "pointerup", this.boundMouseUp );
        canvas.addEventListener( "pointermove", this.boundMouseMove );
      }
    }
  }

  private onTouchDownBEC( e: TouchEvent ): void
  {
    if ( !this.isEnabled ) return;

    e.preventDefault();
    if ( this.stop_event_propagation ) e.stopPropagation();
    if ( e.touches.length !== 1 )
      return;

    if ( this.onDown )
    {
      const t = e.touches[0];
      this.onDown( this.getVec( t.clientX, t.clientY ) );
    }
  }

  private onTouchUpBEC( e: TouchEvent ): void
  {
    if ( !this.isEnabled ) return;

    e.preventDefault();
    if ( this.stop_event_propagation ) e.stopPropagation();
    if ( e.changedTouches.length !== 1 )
      return;

    if ( this.onUp )
    {
      const t = e.changedTouches[0];
      this.onUp( this.getVec( t.clientX, t.clientY ) );
    }
  }

  private onTouchMoveBEC( e: TouchEvent ): void
  {
    if ( !this.isEnabled ) return;

    e.preventDefault();
    if ( this.stop_event_propagation ) e.stopPropagation();
    if ( e.touches.length !== 1 )
      return;

    if ( this.onMove )
    {
      const t = e.touches[0];
      this.onMove( this.getVec( t.clientX, t.clientY ) );
    }
  }

  private onMouseDownBEC( e: MouseEvent ): void
  {
    if ( !this.isEnabled ) return;
    if ( this.stop_event_propagation ) e.stopPropagation();

    if ( this.onDown )
    {
      this.onDown( this.getVec( e.clientX, e.clientY ) );
    }
  }

  private onMouseUpBEC( e: MouseEvent ): void
  {
    if ( !this.isEnabled ) return;
    if ( this.stop_event_propagation ) e.stopPropagation();

    if ( this.onUp )
    {
      this.onUp( this.getVec( e.clientX, e.clientY ) );
    }
  }


  private onMouseMoveBEC( e: MouseEvent ): void
  {
    if ( !this.isEnabled ) return;
    if ( this.stop_event_propagation ) e.stopPropagation();

    if ( this.onMove )
      this.onMove( this.getVec( e.clientX, e.clientY ) );
  }

  private getVec( x: number, y: number ): Vector2
  {
    //if ( !this.bounding_client_rect )
    //  return new Vector2( x, y );

    const bounding_client_rect = this.canvas.getBoundingClientRect();
    //console.log( `getVec( x ${x}, y ${y} )` );
    //console.log( `bounding_client_rect ${bounding_client_rect.x}, ${bounding_client_rect.y}, ${bounding_client_rect.left}, ${bounding_client_rect.top}, ${bounding_client_rect.width}, ${bounding_client_rect.height}` );

    return new Vector2(
      x - bounding_client_rect.left,
      y - bounding_client_rect.top
    );
  }

  public disable(): void
  {
    this.isEnabled = false;
  }

  public enable(): void
  {
    this.isEnabled = true;
  }

  public cleanup(): void
  {
    this.isEnabled = false;
    this.isInitialized = false;

    if ( Game.isMobile() )
    {
      if ( this.boundTouchStart )
        this.canvas.removeEventListener( "touchstart", this.boundTouchStart );
      if ( this.boundTouchEnd )
        this.canvas.removeEventListener( "touchend", this.boundTouchEnd );
      if ( this.boundTouchMove )
        this.canvas.removeEventListener( "touchmove", this.boundTouchMove );
    } else
    {
      if ( this.use_global_mouse_events )
      {
        if ( this.boundMouseDown )
          window.removeEventListener( "pointerdown", this.boundMouseDown );
        if ( this.boundMouseUp )
          window.removeEventListener( "pointerup", this.boundMouseUp );
        if ( this.boundMouseMove )
          window.removeEventListener( "pointermove", this.boundMouseMove );
      } else
      {
        if ( this.boundMouseDown )
          this.canvas.removeEventListener( "pointerdown", this.boundMouseDown );
        if ( this.boundMouseUp )
          this.canvas.removeEventListener( "pointerup", this.boundMouseUp );
        if ( this.boundMouseMove )
          this.canvas.removeEventListener( "pointermove", this.boundMouseMove );
      }
    }

    this.boundTouchStart = undefined;
    this.boundTouchEnd = undefined;
    this.boundTouchMove = undefined;
    this.boundMouseDown = undefined;
    this.boundMouseUp = undefined;
    this.boundMouseMove = undefined;
    
    this.onDown = undefined;
    this.onUp = undefined;
    this.onMove = undefined;
  }
}
